export default (sentence: string, values: any[] = []): string => {
  const placeholderRegex = /\{\{(.+?)\}\}/g;

  if (values.length === 0 || !placeholderRegex.test(sentence)) {
    return sentence;
  }

  let index = 0;
  return sentence.replace(placeholderRegex, () => {
    const value = values[index++];
    return value !== undefined ? String(value) : '';
  });
}
